export default class QuickSearch {

    constructor() {
    }

    init() {
        let woofTextSelect = $('input[name="woof_text"]');

        let self = this;
        woofTextSelect.keypress(function (e) {
            if (e.which === 13) {
                self.redirectToShopPage();
                return false;
            }
        });

        $('.header__search-cta').click(function () {
            self.redirectToShopPage();
        });
    }

    redirectToShopPage() {

        let woofTextSelect = $('input[name="woof_text"]');

        let woofTextValue = woofTextSelect.val().trim();

        let searchPage = $('input[name="shop_page"]').val();

        if (woofTextValue) {

            let translator = new CyrLatConverter().init({
                ignoreClasses: ['ignore'],
            });

            const cyrillicPattern = /^[\u0400-\u04FF]+$/;
            const originalText = woofTextValue;

            let strArray = woofTextValue.split(" ");

            let woofText = '';

            for(let i = 0; i < strArray.length; i++) {

                if (i >0){
                    woofText += '|';
                }

                if (!cyrillicPattern.test(strArray[i])) {
                    woofText += strArray[i] + '|' + translator.getL2C(strArray[i]);
                }else{
                    woofText += strArray[i] + '|' + translator.getC2L(strArray[i]);
                }
            }

            console.log(woofText);

            searchPage = searchPage + `&woof_text=${woofText}&original_text=${originalText}`;
        }

        window.location.href = searchPage;
    }

}



// WEBPACK FOOTER //
// ./static/js/components/QuickSearch.js